module.exports = __webpack_public_path__ + "coca-cola.png?0bb99b2500a60314a0f3ec4b3b90efd0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coca-cola.png
// module id = 32
// module chunks = 0